// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"OldWorkplaceFrame_ProseMirror__1Y_Pr","oldWorkplaceFrame":"OldWorkplaceFrame_oldWorkplaceFrame__2keyH","rotate-shadow":"OldWorkplaceFrame_rotate-shadow__39O00"};